import { globalEventBus } from '@fiverr-private/futile';
import { isBrowser } from '../../utils/isBrowser';
import { EVENTS, EVENT_READY_SYMBOLS } from '../constants';
import type { EventProps } from '../../types';

type Callback<T> = (payload?: EventProps<T>) => void;
type EventCallbackMap<T> = { [key in keyof typeof EVENTS]?: Callback<T> };

/**
 * Should be used only inside of layout. Not for external use.
 */
export const registerFloatingChatListeners = <T>(callbacksMap: EventCallbackMap<T>) => {
    if (!isBrowser()) {
        return;
    }

    Object.entries(callbacksMap).forEach(([eventKey, callback]) => {
        const typedEventKey = eventKey as keyof typeof EVENTS;
        const eventName = EVENTS[typedEventKey];
        const readySymbol = EVENT_READY_SYMBOLS[typedEventKey];

        if (eventName && callback) {
            globalEventBus.on(eventName, callback);

            // Set the corresponding ready flag dynamically
            if (readySymbol) {
                window[readySymbol] = true;
            }
        }
    });
};

/**
 * Should be used only inside of layout. Not for external use.
 */
export const unregisterFloatingChatListeners = <T>(callbacksMap: EventCallbackMap<T>) => {
    if (!isBrowser()) {
        return;
    }

    Object.entries(callbacksMap).forEach(([eventKey, callback]) => {
        const typedEventKey = eventKey as keyof typeof EVENTS;
        const eventName = EVENTS[typedEventKey];
        const readySymbol = EVENT_READY_SYMBOLS[typedEventKey];

        if (eventName && callback) {
            globalEventBus.off(eventName, callback);

            // Clear the corresponding ready flag dynamically
            if (readySymbol) {
                window[readySymbol] = false;
            }
        }
    });
};
